import React, { } from 'react';
import { useState, useEffect } from 'react';
import { Document, toDisplayDocument } from "shared/models/site/document"

import {
    Button
    , ModalBody
    , Row
    , Col
} from 'reactstrap';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import './DocumentAdmin.css'
import { DocumentAddEditState, documentAddEditState } from './AddEditDocumentState'
import { ModalSubHeader } from './AddEditDocument';
import { RelatedDocumentList } from './RelatedDocuments';

export const SecondPage = (props: {
    completeAction: (document: Document) => void,
    backAction: () => void,
    isComplete: boolean,
}) => {

    const [document, setDocument] = useState({} as Document)
    const [completing, setCompleting] = useState(false)

    useEffect(() => {
        const sub = documentAddEditState.subscribe((s: DocumentAddEditState) => {
            setDocument(s.document)
        });

        return () => { sub.unsubscribe(); };
    }, []);


    const displayDocument = toDisplayDocument(document);

    const completeAction = () => {
        setCompleting(true);
        props.completeAction(document);
    }

    const items = [
        { label: "Document type", value: displayDocument.typeLabel },
        { label: "Document sub-type", value: displayDocument.subTypeLabel || 'N/A' },
        { label: "Document department", value: (displayDocument.departmentNames || []).length > 0 ? displayDocument.departmentNames?.join(', ') : '' },
        { label: "Document Team", value: (displayDocument.departmentTeams || []).length > 0 ? displayDocument.departmentTeams?.join(', ') : 'All' },
        { label: "Document Personnel", value: (displayDocument.personnelId || []).length > 0 ? displayDocument.personnel?.map(p => p.fullName)?.join(', ') : 'All' },
        { label: "Document title", value: displayDocument.title },
        { label: "Document number", value: displayDocument.documentNumber },
        { label: "Version number", value: displayDocument.versionNumber },
        { label: "Related documents", value: (displayDocument.relatedDocuments || []).length > 0 ? <RelatedDocumentList documents={displayDocument.relatedDocuments || []} /> : <>N/A</> },
        { label: "Effective from date", value: `${displayDocument.effectiveFromDateDisplay} ${displayDocument.effectiveFromTime}` },
        { label: "Expiry date", value: `${displayDocument.expiryDateDisplay || 'N/A'} ${displayDocument.expiryTime || ''}` },
        { label: "Notification and acknowledgement", value: `${displayDocument.requiresAcknowledgementAndNotify ? "YES" : "NO"}` },
        { label: "Review", value: `${displayDocument.reviewPeriodDisplay}` },
        { label: "Selected file", value: displayDocument.file ? displayDocument.file.name : displayDocument.fileName || "Error!" },
        { label: "Release Notes", value: displayDocument.releaseNotes },
        { label: "Rescind Document Reason", value: displayDocument.rescindDocumentReason },
    ]
    return (
        <React.Fragment>
            <ModalSubHeader>
                <div className="tab-header tab-header-text-select">Check document details and confirm your upload</div>
            </ModalSubHeader>

            <ModalBody className="pb-5 ml-4 document-admin-body">
                <>
                    {items.map((x, i) => {
                        const className = (i % 2 === 0) ? 'p-2' : 'alternate-row p-2'
                        return (
                            <Row key={i} className={className}>
                                <Col className="col-4 my-auto">{x.label}:</Col>
                                <Col>{x.value}</Col>
                            </Row>
                        )
                    })}
                    <div className="pb-3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {props.isComplete
                            ? <Button className="btn-primary pr-4 pl-4 m-4" >Complete</Button>
                            : <React.Fragment>
                                {completing
                                    ?
                                    <React.Fragment>
                                        <Button className="btn-primary pr-4 pl-4 m-4" disabled>Uploading</Button>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <Button className="btn-secondary pr-4 pl-4 m-4" onClick={props.backAction}>Edit</Button>
                                        <Button className="btn-primary pr-4 pl-4 m-4" onClick={completeAction}>Upload</Button>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
                </>
            </ModalBody>
        </React.Fragment>
    );
}